import { RoleType } from '@feature/security';

export const travelReferenceDocumentKindList = ['PROCEDURE_SG_04', 'PROCEDURE_CC_13', 'USER_GUIDE'] as const;

export type TravelReferenceDocumentKind = (typeof travelReferenceDocumentKindList)[number];

// The extension sits beside the MIME type because a PDF the OS has no registered type for is hidden by a MIME-only filter.
export const travelReferenceDocumentAccept = 'application/pdf,.pdf';

// A null role is the general guide, or a procedure, which no role owns.
export interface TravelReferenceDocumentSlotRef {
  kind: TravelReferenceDocumentKind;
  role: RoleType | null;
}

export interface TravelReferenceDocumentFile extends TravelReferenceDocumentSlotRef {
  present: true;
  fileName: string;
  size: number;
  uploadedAt: string;
  uploadedByName: string | null;
}

export interface TravelReferenceDocumentEmptySlot extends TravelReferenceDocumentSlotRef {
  present: false;
  fileName: null;
  size: null;
  uploadedAt: null;
  uploadedByName: null;
}

export type TravelReferenceDocumentSlot = TravelReferenceDocumentFile | TravelReferenceDocumentEmptySlot;

export interface TravelReferenceDocumentUploadRequest extends TravelReferenceDocumentSlotRef {
  file: File;
}

// The reader endpoint resolves the caller's guide, the slot endpoint returns exactly the slot an admin names.
export type TravelReferenceDocumentContentSource = 'resolved' | 'slot';
